// Canonical size / length options and display formatting for service pricing
// combinations and task pricing rows. Kept in one place so the service editor,
// the task-pricing editor, and the read-only tables can't drift apart.

export const SIZE_OPTIONS: string[] = ['XXS', 'XS', 'S', 'SM', 'M', 'L', 'XL', 'JUMBO'];

export const LENGTH_OPTIONS: string[] = [
	'SHOULDER',
	'BRA',
	'MID_BACK',
	'WAIST',
	'BUTT',
	'HIP',
	'THIGH',
	'KNEE',
];

const SIZE_LABELS: Record<string, string> = {
	XXS: 'XXS',
	XS: 'XS',
	S: 'Small',
	SM: 'SM',
	M: 'Medium',
	L: 'Large',
	XL: 'XL',
	JUMBO: 'Jumbo',
};

/**
 * Label shown when a pricing row has no size or length. Rows priced by
 * duration alone are stored with both blank, and blank means "any".
 */
export const ANY_SIZE_LABEL = 'Any';

/** Human label for a size code, e.g. "M" → "Medium". Unknown codes pass through; blank → "Any". */
export const formatSize = (size: string | null | undefined): string =>
	size ? SIZE_LABELS[size] || size : ANY_SIZE_LABEL;

/** Human label for a length code, e.g. "MID_BACK" → "Mid Back". Blank → "Any". */
export const formatLength = (length: string | null | undefined): string =>
	length
		? length
				.split('_')
				.map(word => word.charAt(0) + word.slice(1).toLowerCase())
				.join(' ')
		: ANY_SIZE_LABEL;

/**
 * Mirror of the backend's SizeLengthUtils.covers: a blank row value is a
 * wildcard that matches any request; otherwise the request must match it,
 * case-insensitively.
 */
export const sizeLengthCovers = (
	rowValue: string | null | undefined,
	requested: string | null | undefined
): boolean => {
	if (!rowValue?.trim()) return true;
	return !!requested?.trim() && rowValue.trim().toUpperCase() === requested.trim().toUpperCase();
};
